import axios, { AxiosResponse } from 'axios';
import { ILeiRejstrikInput, ILeiRejstrikResp } from 'types/leiTypes';

const leiRejstrkApi = (data: ILeiRejstrikInput) => {
    return axios({
        method: 'GET',
        url: '/LEI/Rejstrik',
        params: data
    }).then((resp: AxiosResponse<ILeiRejstrikResp>) => resp.data);
};

export default leiRejstrkApi;
